// import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
// import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://7cb4c1205cd06d6af1f06fadbb5cf530@o1114593.ingest.sentry.io/4505721035227136',
    environment: process.env.NODE_ENV,
    integrations: [
      // new Sentry.BrowserTracing({
      //   // See docs for support of different versions of variation of react router
      //   // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      //   routingInstrumentation: Sentry.reactRouterV6Instrumentation(
      //     useEffect,
      //     useLocation,
      //     useNavigationType,
      //     createRoutesFromChildren,
      //     matchRoutes,
      //   ),
      // }),
      new Sentry.Replay({
        networkDetailAllowUrls: [
          'pov.stg.acertusmarketplace.io',
          'pov.prd.acertusmarketplace.io',
          'shipmycar.acertusdelivers.com'
        ]
        // networkRequestHeaders: ['X-Custom-Header'],
        // networkResponseHeaders: ['X-Custom-Header'],
      })
    ],
    // Performance Monitoring
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1, // Capture 100% of the transactions, reduce in production!
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  });
};
